import React, { Component } from 'react';
import { connect } from 'react-redux';
import { translate } from 'react-admin';
import { refreshView } from 'ra-core';
import LinearProgress from '@material-ui/core/LinearProgress';
import api from '~config/api';

const POLL_MS = 3000;
// After clicking "Recalcular", the banner shows immediately for this long even before the
// first poll confirms the backend flag (which can lag a moment behind the job starting).
const OPTIMISTIC_MS = 8000;

// Module-level optimistic trigger: the recompute button calls markRecomputeStarted() so the
// banner appears instantly in the current view; polling then keeps it accurate (and surfaces
// it in the other list view too).
let optimisticUntil = 0;
export function markRecomputeStarted() {
  optimisticUntil = Date.now() + OPTIMISTIC_MS;
}

const bannerStyle = {
  display: 'flex',
  alignItems: 'center',
  gap: 12,
  padding: '10px 16px',
  marginBottom: 8,
  backgroundColor: '#e3f2fd',
  border: '1px solid #90caf9',
  borderRadius: 4,
  color: '#0d47a1',
  fontWeight: 500
};

class RecomputeStatusBanner extends Component {
  state = { isRecomputing: false };

  // Tracks the previous BACKEND running state (not the optimistic-inflated UI state) so we can
  // detect the running -> finished transition and refresh the list exactly once.
  wasBackendRunning = false;

  componentDidMount() {
    this._mounted = true;
    this.poll();
    this.interval = setInterval(this.poll, POLL_MS);
  }

  componentWillUnmount() {
    this._mounted = false;
    clearInterval(this.interval);
  }

  poll = () => {
    api.get('/metrics/recompute-status/').then(response => {
      if (!this._mounted) {
        return;
      }
      const backendRunning = Boolean(response.ok && response.data && response.data.isRecomputing);
      // Recompute just finished: refresh the current list so it shows the rebuilt data.
      // This component only mounts inside the Metrics / MetricValues list views, so the
      // refresh is inherently scoped to those screens.
      if (this.wasBackendRunning && !backendRunning) {
        this.props.refreshView();
      }
      this.wasBackendRunning = backendRunning;

      const optimistic = Date.now() < optimisticUntil;
      this.setState({ isRecomputing: backendRunning || optimistic });
    });
  };

  render() {
    const { translate: t } = this.props;
    if (!this.state.isRecomputing) {
      return null;
    }
    return (
      <div style={bannerStyle}>
        <span>{t('metrics.recomputeInProgress')}</span>
        <LinearProgress style={{ flex: 1 }} />
      </div>
    );
  }
}

export default translate(connect(null, { refreshView })(RecomputeStatusBanner));
